import { proxy } from 'valtio';
import { TentTypeV1, TENT_TYPE_V1_TO_NIVAAS_SLUG } from '@camp67/model';
import { NivaasOffering, getOfferingFullRoomPrice } from '../types/offerings';

/**
 * Global offerings state - populated from root loader
 */
export const offeringsState = proxy<{
  offerings: NivaasOffering[];
  initialized: boolean;
}>({
  offerings: [],
  initialized: false,
});

/**
 * Get offering by tent type
 */
export function getOfferingByTentType(tentType: TentTypeV1): NivaasOffering | undefined {
  const slug = TENT_TYPE_V1_TO_NIVAAS_SLUG[tentType];
  return offeringsState.offerings.find((o) => o.slug === slug);
}

/**
 * Get full room price from offerings for a tent type
 * Returns the price in INR (unit_price * capacity), or undefined if not found
 */
export function getOfferingPrice(tentType: TentTypeV1): number | undefined {
  const offering = getOfferingByTentType(tentType);
  const price = getOfferingFullRoomPrice(offering);
  return price?.amount;
}

/**
 * Get capacity from offerings for a tent type
 */
export function getOfferingCapacity(tentType: TentTypeV1): number | undefined {
  const offering = getOfferingByTentType(tentType);
  return offering?.capacity;
}

/**
 * Initialize offerings state from loader data
 */
export function initializeOfferings(offerings: NivaasOffering[]) {
  offeringsState.offerings = offerings;
  offeringsState.initialized = true;
}
